<!-- 巡检同期对比 -->
<template>
  <div class="inspection-period">

    <div class="chart-container">
      <div ref="chartRef" class="chart"></div>
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts'
import { postAction } from '@/api/manage'

export default {
  name: 'InspectionPeriod',
  data() {
    return {
      title: this.$t('巡检同期对比'),
      url: {
        LargeScreenTwoYearsIncreaseInspection: "/jeecg-engineering/inspection/inspectionTask/LargeScreenTwoYearsIncreaseInspection"
      },
      chart: null
    }
  },
  mounted() {
    this.init()
  },
  beforeDestroy() {
    this.disposeChart()
  },
  methods: {
    init() {
      this.getData()
    },
    getData() {
      postAction(this.url.LargeScreenTwoYearsIncreaseInspection, { planType: 1 }).then(res => {
        if (res.success) {
          const data = res.result
          this.setOption(data)
        }
      }).catch(() => {
        this.loadMockData()
      })
    },
    loadMockData() {
      const mockData = [
        { time: '1月', lastYearNum: 25, thisYearNum: 32 },
        { time: '2月', lastYearNum: 28, thisYearNum: 35 },
        { time: '3月', lastYearNum: 30, thisYearNum: 38 },
        { time: '4月', lastYearNum: 32, thisYearNum: 42 },
        { time: '5月', lastYearNum: 35, thisYearNum: 45 },
        { time: '6月', lastYearNum: 38, thisYearNum: 48 }
      ]
      this.setOption(mockData)
    },
    setOption(data) {
      let y1 = [];
      let y2 = [];
      let xData = [];
      data.map(item => {
        y1.push(item.lastYearNum);
        y2.push(item.thisYearNum);
        xData.push(item.time);
      });
      
      const option = {
        color: ['#50E3C2', '#0394FF'],
        title: {
          show: false
        },
        tooltip: {
          trigger: 'axis',
          backgroundColor: 'rgba(0,11,42,0.9)',
          borderColor: '#5D6A94',
          borderWidth: 1,
          borderRadius: 8,
          textStyle: {
            color: '#CEE2FF',
          },
          axisPointer: {
            type: 'line',
            lineStyle: {
              color: '#019AF3'
            }
          }
        },
        legend: {
          type: 'scroll',
          data: [this.$t('去年'), this.$t('今年')],
          textStyle: {
            color: '#CEE2FF'
          },
          itemHeight: 10,
          right: 0
        },
        grid: {
          left: '3%',
          right: '3%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          boundaryGap: true,
          data: xData,
          splitLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: ['#074671']
            }
          },
          axisLabel: {
            color: '#D1F3FF',
            fontSize: 10
          }
        },
        yAxis: [
          {
            type: 'value',
            name: this.$t('单位:次'),
            nameTextStyle: {
              color: '#D1F3FF',
              align: 'center'
            },
            splitLine: {
              show: true,
              lineStyle: {
                type: 'dotted',
                color: ['#074671']
              }
            },
            axisTick: {
              show: false
            },
            axisLine: {
              show: false
            },
            axisLabel: {
              color: '#D1F3FF',
              fontSize: 10
            }
          }
        ],
        series: [
          {
            name: this.$t('去年'),
            type: 'bar',
            barMaxWidth: 14,
            data: y1,
            smooth: true,
            symbol: "none",
            animationDelay: (0 * 200) - 100,
            animationDuration: 300
          },
          {
            name: this.$t('今年'),
            type: 'bar',
            barMaxWidth: 14,
            barGap: "10%",
            data: y2,
            smooth: true,
            symbol: "none",
            animationDelay: (0 * 200) - 100,
            animationDuration: 300
          }
        ]
      }
      
      this.initChart(option)
    },
    initChart(option) {
      this.disposeChart()
      
      if (!this.$refs.chartRef) return
      
      this.chart = echarts.init(this.$refs.chartRef)
      this.chart.setOption(option)
      
      window.addEventListener('resize', this.handleResize)
    },
    handleResize() {
      if (this.chart) {
        this.chart.resize()
      }
    },
    disposeChart() {
      if (this.chart) {
        this.chart.dispose()
        this.chart = null
        window.removeEventListener('resize', this.handleResize)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.inspection-period {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  background: rgba(0, 48, 111, 0.2);
  border: 1px solid rgba(0, 170, 255, 0.2);
  border-radius: 8px;
  overflow: hidden;
}

.period-header {
  padding: 15px;
  border-bottom: 1px solid rgba(0, 170, 255, 0.2);
  background: linear-gradient(135deg, rgba(1, 32, 67, 0.8) 0%, rgba(0, 48, 111, 0.6) 100%);
}

.header-title {
  color: #b6deff;
  font-size: 16px;
  font-weight: 500;
  text-align: left;
}

.chart-container {
  flex: 1;
  padding: 15px;
}

.chart {
  width: 100%;
  height: 100%;
}

@media (max-width: 1600px) {
  .period-header {
    padding: 12px;
  }
  
  .header-title {
    font-size: 14px;
  }
  
  .chart-container {
    padding: 12px;
  }
}

@media (max-width: 1200px) {
  .period-header {
    padding: 10px;
  }
  
  .header-title {
    font-size: 13px;
  }
  
  .chart-container {
    padding: 10px;
  }
}
</style>